import React from 'react';
import ReactPlayer from 'react-player';
import { Box, Typography } from '@mui/material';

const VideoPlayer = ({
  videoUrl,
  title,
  width = '100%',
  height = '100%',
  controls = true,
}) => {
  if (!videoUrl) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      {title && (
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          {title}
        </Typography>
      )}
      <ReactPlayer
        url={videoUrl}
        width={width}
        height={height}
        controls={controls}
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload',
            },
          },
        }}
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      />
    </Box>
  );
};

export default VideoPlayer;
